
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import Dator from "@/utils/censor.js";

export default {
name: "forget",
components: {
XInput,
Group,
Picker,
Popup
},
data() {
return {
iconNone: require("@/assets/image/icon/dele.png"),
iconAll: {
iconLogo: require("@/assets/image/icon/logo.png"),
wechatLogo: require("@/assets/image/icon/wechat_logo.png"),
facebookLogo: require("@/assets/image/icon/facebook_logo.png"),
googleLogo: require("@/assets/image/icon/google_logo.png")
},
second: 0,
formD: {
email: "",
password: "",
passwordConfirm: "",
code: ""
}
};
},
methods: {

onClickLeft(){
this.$router.go(-1)
},

sendEmailCode() {
if (this.second > 0) {
return;
}

let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.emailNullErr') },
{ strategy: "checkEmail", errMsg: this.$t('FORGET_LANG.emailErr') }
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

let postD = {
email: this.formD.email
};
this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.FORGETCODE, postD, "POST")
.then(res => {


this.$toast.text(this.$t('FORGET_LANG.sendCode'));
this.second = 60;
this.startCounting();
})
.catch(err => {

this.$toast.text(this.$t('FORGET_LANG.getCodeErr')+"：" + err.response.data.message);
});
},
startCounting() {
let _this = this;

if (this.second > 0) {
setTimeout(() => {
_this.second -= 1;
_this.startCounting();
}, 1000);
}
},

doResetPassword() {
let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.emailNullErr') },
{ strategy: "checkEmail", errMsg:  this.$t('FORGET_LANG.emailErr') }
]);

dator.add(this.formD.code, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputCode') },
{ strategy: "checkStringFormat:4:1", errMsg: this.$t('FORGET_LANG.CodeErr') }
]);

dator.add(this.formD.password, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputPassThree')},
{ strategy: "checkPassworld", errMsg: this.$t('FORGET_LANG.passMessage') }
]);

dator.add(this.formD.passwordConfirm, [
{ strategy: "isEmpty", errMsg:  this.$t('FORGET_LANG.inputPassFour') },
{ strategy: "checkPassworld", errMsg:  this.$t('FORGET_LANG.passMessage')}
]);

dator.add(this.formD.passwordConfirm, [
{
strategy: "checkEqual:" + this.formD.password,
errMsg: this.$t('FORGET_LANG.passMessage')
}
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}


let postD = {
password: this.formD.password,
email: this.formD.email,
code: this.formD.code
};

console.log("postD", postD);

this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.FORGETPASSWORD, postD, "POST")
.then(res => {
console.log("res", res);

this.$toast.text(this.$t('FORGET_LANG.resetPassSuccess'));
this.GLOBAL_.ccApp.navigateBack();
})
.catch(err => {

let res = err.response;
this.$toast.text(this.$t('FORGET_LANG.resetPassFail')+"：" + res.data.message);
});
}
},
created() {

},
mounted: function() {

}
};



// WEBPACK FOOTER //
// ./src/pages/login/forget.vue